import React, { Component } from 'react'
import '../App.css'
import anime from 'animejs'
import Score from './Score.js'
import GameOver from './GameOver.js'
import StartButton from './StartButton.js'
import classNames from 'classnames'
import MoleHole from './MoleHole.js'
import logo from '../../public/assets/logo.svg'
import adamHit from '../../public/assets/adam-hit.png'
import adamIdle from '../../public/assets/adam-idle.png'
import nellieHit from '../../public/assets/nellie-hit.png'
import nellieIdle from '../../public/assets/nellie-idle.png'
import sofiaHit from '../../public/assets/sofia-hit.png'
import sofiaIdle from '../../public/assets/sofia-idle.png'
import kotteHit from '../../public/assets/kotte-hit.png'
import kotteIdle from '../../public/assets/kotte-idle.png'
import nisseHit from '../../public/assets/nisse-hit.png'
import nisseIdle from '../../public/assets/nisse-idle.png'
import YouTube from 'react-youtube'

class App extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      1: 'translate(0, 110%)',
      2: 'translate(0, 110%)',
      3: 'translate(0, 110%)',
      4: 'translate(0, 110%)',
      5: 'translate(0, 110%)',
      6: 'translate(0, 110%)',
      7: 'translate(0, 110%)',
      8: 'translate(0, 110%)',
      9: 'translate(0, 110%)',
      shake: 'translate(0, 0)',
      gameHasStarted: false,
      moleHasBeenWhacked: false,
      score: 0,
      lastMole: '',
      currentMole: '',
      display: 'none',
      buttonMessage: 'Start Game',
      gameOver: 'none',
      buttonDisplay: 'inline-block',
      titleMargin: '15px',
      player: '',
      gameRunning: false,
    }
  }

  animate(el) {
    anime({
      targets: el,
      direction: 'alternate',
      loop: true,
      easing: 'easeInQuad',
      duration: 1600,
      scale: function (el, i, l) {
        return l - i + 0.08
      },
    })
  }

  timeOut(num) {
    if (this.state.gameHasStarted) {
      return
    }

    if (this.state.player) {
      this.state.player.playVideo()
    }

    this.setState({
      buttonDisplay: 'none',
      display: 'block',
      gameOver: 'none',
      titleMargin: 0,
    })
    this.shakeScreen()
    window.setTimeout(() => {
      this.startGame()
    }, num)
  }

  startGame() {
    if (this.state.gameHasStarted) {
      return
    }

    this.setState({
      gameHasStarted: true,
      score: 0,
    })

    let x = 0

    function run(ctx) {
      let timeout = Math.ceil(Math.random() * 9) * 100 + 300

      setTimeout(() => {
        ctx.displayMoles()
        if (++x === 26) {
          // KOTTE: Rounds
          // window.clearTimeout(intervalID)
          ctx.clearMoles()
          window.setTimeout(() => {
            ctx.setState({
              gameHasStarted: false,
              display: 'none',
              gameOver: 'block',
              buttonMessage: 'Play again',
              buttonDisplay: 'inline-block',
              titleMargin: '15px',
            })
            ctx.animate(ctx.refs.gameOver)
          }, 1000)
        } else {
          run(ctx)
        }
      }, timeout) // loop
    }

    run(this)
  }

  clearMoles() {
    for (let value in this.state) {
      if (!isNaN(value)) {
        this.setState({
          [value]: 'translate(0, 110%)',
        })
      }
    }
  }

  displayMoles() {
    let activeMole = Math.ceil(Math.random() * 9)
    if (this.state.lastMole[0] === activeMole) {
      this.displayMoles()
      return
    }
    this.clearMoles()
    this.setState({
      currentMole: activeMole,
      [activeMole]: 'translate(0, 10%)',
      lastMole: [activeMole],
    })
  }

  lockOutClick() {
    window.setTimeout(() => {
      this.setState({ moleHasBeenWhacked: false })
    }, 350)
  }

  addToScore(e) {
    if (this.state.moleHasBeenWhacked) {
      return
    }
    let target = e.target
    target.parentNode.classList.add('game__cross')
    target.classList.add('no-background')
    this.lockOutClick()
    this.setState({
      background: '75px',
      moleHasBeenWhacked: true,
      score: [parseInt(this.state.score, 10) + 1],
    })
    window.setTimeout(function () {
      target.parentNode.classList.remove('game__cross')
      target.classList.remove('no-background')
    }, 700)
  }

  shakeScreen() {
    let posOrNeg = '+'
    let i = 0
    let shake = () => {
      if (i === 15) {
        this.setState({ shake: 'translate(0, 0)' })
        return
      }
      window.setTimeout(() => {
        posOrNeg = posOrNeg === '-' ? '+' : '-'
        this.setState({ shake: `translate(${posOrNeg}${i}px, 0)` })
        shake()
      }, 80)
      i++
    }
    shake()
  }

  createMoleHoles() {
    var holes = []
    for (let i = 1; i <= 9; i++) {
      holes.push(
        <MoleHole
          key={i}
          context={this.state}
          currentMole={this.state.currentMole}
          onClick={this.addToScore.bind(this)}
          holeNumber={i}
        />
      )
    }
    return <div className="board">{holes}</div>
  }

  render() {
    return (
      <div
        className={classNames([
          'main-container',
          this.state.gameHasStarted && 'has-started',
        ])}
      >
        <div className="game" style={{ WebkitTransform: this.state['shake'] }}>
          {!this.state.gameHasStarted && (
            <h1
              className="game__title"
              style={{ margin: this.state.titleMargin }}
            >
              WHACK-A-BLUE
            </h1>
          )}
          {!this.state.gameHasStarted &&
            this.state.gameOver === 'none' &&
            this.state.buttonDisplay === 'inline-block' && (
              <p style={{ margin: this.state.titleMargin }}>
                You played me well and I can tell I didn't do that swell.
                <br />
                <br />
              </p>
            )}

          <GameOver context={this} />
          <div ref={'gameOver'} className="game__button-container">
            <StartButton
              context={this.state}
              onClick={this.timeOut.bind(this)}
            />
          </div>
          <div>{this.createMoleHoles()}</div>
          <Score context={this.state} />
        </div>

        <img src={logo} className="logo" alt={logo} />
        <div className="player">
          <YouTube
            videoId="QoP8N7vXIPw"
            onReady={(event) => {
              event.target.seekTo(1.2)
              this.setState({ player: event.target })
            }}
            onEnd={(event) => {
              event.target.seekTo(1.2)
              event.target.playVideo()
            }}
            opts={{
              playerVars: {
                playsinline: 1,
              },
            }}
          />
        </div>
        <div className="cache">
          <img src={adamHit} alt="cache" />
          <img src={adamIdle} alt="cache" />
          <img src={nellieHit} alt="cache" />
          <img src={nellieIdle} alt="cache" />
          <img src={sofiaHit} alt="cache" />
          <img src={sofiaIdle} alt="cache" />
          <img src={kotteHit} alt="cache" />
          <img src={kotteIdle} alt="cache" />
          <img src={nisseHit} alt="cache" />
          <img src={nisseIdle} alt="cache" />
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js